import LoadingSpinner from "components/LoadingSpinner";
import { Config } from "Config";
import { FC, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

interface EmbedProps {
  url: string;
  listenToMessages?: boolean;
  loader?: JSX.Element;
}

const Embed: FC<EmbedProps> = ({ url, listenToMessages, loader }) => {
  const [show, setShow] = useState<boolean>(listenToMessages ? false : true);
  const [controller] = useState(new AbortController());
  const iframe = useRef(null);

  const onMessageListener = (event) => {
    if (iframe.current && event.source === iframe.current["contentWindow"]) {
      if (event.origin === Config.lookerOrigin) {
        const data = JSON.parse(event.data);
        if (data.type === "look:run:complete") {
          setShow(true);
        }
      }
    }
  };

  useEffect(() => {
    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (iframe.current && Config.lookerOrigin && listenToMessages) {
      window.addEventListener("message", onMessageListener, { signal: controller.signal });
    }
  }, [iframe.current, listenToMessages]);

  useEffect(() => {
    if (show) {
      controller.abort();
    }
  }, [show]);

  return (
    <>
      {!show && <>{loader || LoadingSpinner}</>}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
        <iframe
          ref={iframe}
          src={url}
          style={{
            border: "0",
            width: "100%",
            height: "100%",
            visibility: show ? "visible" : "hidden",
            position: show ? "relative" : "absolute",
          }}
        />
      </Box>
    </>
  );
};

export default Embed;
